export default __webpack_public_path__ + "static/media/tbtcMintingStep1.68bd020f.svg";